














import Vue from 'vue';
import AmexBtn from '@common/button/button.vue';
import Tag from '@common/filter-tag/tag.vue';

export default Vue.extend({
  components: {
    AmexBtn,
    Tag,
  },
  name: 'AmexFilterBtn',
  props: {
    label: String,
    value: String,
    tag: Object,
    withCheck: Boolean,
  },
});
